<template>
  <div ref='mainScreen' v-if="!isMobile()">
    <div id="home" class="home select-none cursor-default" ref="body">
      <!-- <MenuButton /> -->
      <div v-if="page === 'resume'" >
        <div class="flex-box items-center justify-around cursor-default">
          <img class="mx-auto h-96" alt="Vue logo" src="../assets/Logo.svg">
        </div>
        <AboutMe />
        <AchievementHolder :key="achievement" v-for="achievement in achievements" :title="achievement[0]" :positions="achievement[1]"/>
        <Skills />
      </div >
      <div v-if="page === 'playground'" class="flex flex-row items-center justify-center">
        <MLPlayground />
      </div>
      <div v-if="page === 'about'" class="flex flex-row items-center justify-center">
        <LongerAboutMe />
      </div>
    </div>
    <transition name="slide">
      <div v-if="easterEggVar" class="m-auto justify-center z-30 fixed inset-x-0 inset-y-0 h-screen w-screen cursor-none hover:cursor-pointer font-text bg-black">
        <Terminal class="flex flex-col select-none overflow-auto" />
      </div>
    </transition>
  </div>
  <div v-else>
    <Mobile :achievements="achievements"/>
  </div>
</template>

<script>
import AboutMe from '@/components/AboutMe.vue'
import Terminal from '@/components/Terminal.vue'
import Mobile from '@/components/mobile/Mobile.vue'
import AchievementHolder from '@/components/AchievementHolder'
import { provide, ref } from 'vue'
import MLPlayground from '@/components/MLPlayground'
import LongerAboutMe from '@/components/LongerAboutMe'
import { useKeypress } from 'vue3-keypress'
import Skills from '@/components/Skills.vue'

export default {
  name: 'Home',
  components: {
    MLPlayground,
    Terminal,
    Skills,
    Mobile,
    LongerAboutMe,
    // MenuButton,
    AboutMe,
    AchievementHolder
  },
  setup: function () {
    const easterEggVar = ref(false)
    const easterEgg = ({ keyCode }) => {
      document.body.style.cursor = 'none'
      easterEggVar.value = true
      console.log('AAAAA')
    }
    useKeypress({
      keyEvent: 'keydown',
      keyBinds: [
        {
          keyCode: 222, // or keyCode as integer, e.g. 40
          success: easterEgg,
          // modifiers: ['shiftKey']
          modifiers: ['ctrlKey', 'shiftKey']
        }
      ]
    })
    const page = ref('resume')
    const loadResume = () => {
      page.value = 'resume'
      console.log(page.value)
    }
    const loadAboutMe = () => {
      page.value = 'about'
      console.log(page.value)
    }
    const loadPlayground = () => {
      page.value = 'playground'
      console.log(page.value)
    }
    provide('easterEggVar', easterEggVar)
    provide('page', page)
    provide('loadResume', loadResume)
    provide('loadPlayground', loadPlayground)
    provide('loadAboutMe', loadAboutMe)
    return {
      page,
      easterEggVar,
      loadResume,
      loadPlayground,
      easterEgg
    }
  },
  data: function () {
    return {
      achievements: [
        ['Current Position', [['Keryx', 'Co-Founder', require('../assets/KeryxLogo.png'), ['https://www.linkedin.com/company/keryx-co/?viewAsMember=true', 'Keryx Corporation', ['fab', 'linkedin']], ['https://kryx.co', 'kryx.co', ['fas', 'link']],
          '<span>Keryx is an advanced workspace for deal management.  Our platform can be used to organize relationships, simplify multi-party workflows, and streamline the process all the way from lead to deal.</span><div class="flex flex-col"><br /><p>With Keryx you can:</p><ul class="list-disc mx-5"><li>' +
          'Build out workflows to automatically organize your inbox, keep track of different parties, and generate individualized messages across multiple leads</li><li>Share your workspace and manage delegations so your team can work as one</li><li>' +
          'Customize your workspace to manage your projects the way you want it</li></ul></div><br /><span>Keryx is currently set for a beta release on <span class="font-bold">January 4<sup>th</sup>, 2022.</span></span>', [[require('../assets/KeryxLogo.png'), 'h-36 mx-auto  ', 'h-36 rounded-logo shadow'], [require('../assets/Keryx/KeryxWebpage.png'), 'h-36 mx-auto px-4', 'h-36 shadow']]]]],
        ['Education', [['Purdue University', 'Computer Science Honors', require('../assets/Purdue.png'), null, null, 'I am currently a student at Purdue University in the Honors College pursuing a Bachelor of Science degree in Computer Science Honors.  Meanwhile, my concentration is in Machine Intelligence.' +
        '  In addition to my ongoing studies, I am looking forward to becoming involved with university research beginning in January 2022.<br>My expected graduation is May 2023.']]],
        ['Certificates', [['Coursera', 'Machine Learning', require('../assets/Coursera.svg'), ['https://www.coursera.org/learn/machine-learning', 'Course Link', ['fas', 'link']], ['https://www.coursera.org/account/accomplishments/certificate/8PFDV27VTUGW', 'Certificate', ['fas', 'certificate']],
          '<p>Several years ago I became interested in furthering my knowledge within Computer Science, and with my interest in machine learning, this Coursera course was perfect.  Through this course I was able to learn about basic Machine Learning concepts such as Linear Regression and' +
          ' Logistic Regression, where I was able to learn about the fundamentals of basic models and practice implementing them.  In addition to developing fundamental skills, I also had the opportunity to learn about more complex models such as Neural Networks, and implement basic logic' +
          ' functions through a Single Layer Perceptron.</p><br /><p>Skills I developed in this course:</p><ul class="list-disc mx-5"><li>Basic Machine Learning Concepts (Linear Regression, Logistic Regression, K-Means Clustering, etc.)</li><li>Basics of Neural Networks</li><li>Model Optimizations</li></ul>', [[require('../assets/MachineLearning/LinearRegression.png'), 'h-36 mx-auto px-4', 'h-36 shadow'], [require('../assets/MachineLearning/LogisticRegression.png'), 'h-36 mx-auto px-4', 'h-36 shadow'],
            [require('../assets/MachineLearning/CurvedLogisticRegression.png'), 'h-36 mx-auto px-4', 'h-36 shadow'], [require('../assets/MachineLearning/PolynomialRegression0.png'), 'h-36 mx-auto px-4', 'h-36 shadow'], [require('../assets/MachineLearning/PolynomialRegression1.png'), 'h-36 mx-auto px-4', 'h-36 shadow'], [require('../assets/MachineLearning/Classification.png'), 'h-36 mx-auto px-4', 'h-36 shadow'], [require('../assets/MachineLearning/KMeansCompression.png'), 'h-36 mx-auto px-4', 'h-36 shadow'], [require('../assets/MachineLearning/Fogretful.png'), 'h-36 mx-auto px-4', 'h-36 shadow'],
            [require('../assets/MachineLearning/Forgetful.png'), 'h-36 mx-auto px-4', 'h-36 shadow']]],
        ['Coursera', 'Deep Learning Specialization', require('../assets/Coursera.svg'), ['https://www.coursera.org/specializations/deep-learning', 'Course Link', ['fas', 'link']], ['https://www.coursera.org/account/accomplishments/specialization/certificate/7CLG69K82DUK', 'Certificate', ['fas', 'certificate']], '<p>' +
          'This course provided me with the skills I needed to better understand and implement complex Deep Learning algorithms.  Covering more complex ideas within the general topic of deep learning such as hyperparameter tuning, regularization, and optimization.  These new ideas allowed me to improve the models I' +
          ' was building and design more complex networks.</p><br /><p>The courses were:</p><ul class="list-disc mx-5"><li>Neural Networks and Deep Learning</li><li>Improving Deep Neural Networks</li><li>Structuring Machine Learning Projects</li><li>Convolutional Neural Networks</li>' +
          '<li>Sequence Models</li></ul>', [[require('../assets/DeepLearning/Classifier1.png'), 'h-36 mx-auto px-4', 'h-36 shadow'], [require('../assets/DeepLearning/Classifier2.png'), 'h-36 mx-auto px-4', 'h-36 shadow'], [require('../assets/DeepLearning/Classifier3.png'), 'h-36 mx-auto px-4', 'h-36 shadow'], [require('../assets/DeepLearning/Classifier4.png'), 'h-36 mx-auto px-4', 'h-36 shadow'],
          [require('../assets/DeepLearning/Classifier5.png'), 'h-36 mx-auto px-4', 'h-36 shadow'], [require('../assets/DeepLearning/Classifier6.png'), 'h-36 mx-auto px-4', 'h-36 shadow']]],
        ['Coursera', 'AI for Medical Diagnosis', require('../assets/Coursera.svg'), ['https://www.coursera.org/learn/ai-for-medical-diagnosis', 'Course Link', ['fas', 'link']], ['https://www.coursera.org/account/accomplishments/certificate/XSUEJ84CK5LF', 'Certificate', ['fas', 'certificate']], '<p>' +
          'This course built off of my previous studies of Neural Networks, teaching me how to successfully implement Neural Networks in the context of medical diagnosis.  This course specifically focused on computer vision which is utilizing Convolutional Neural Networks to aid in the detection of abnormalities on' +
          ' medical imaging.  By far the most interesting concept covered was image registration, as I had previously worked entirely with pristine data.  Learning how to handle imperfect data allowed me to expand my skill set and provide me the skills to apply computer vision models on real world data.</p>', [[require('../assets/Diagnosis/PrecisionRecallCurve.png'), 'h-36 mx-auto px-4', 'h-36 shadow'], [require('../assets/Diagnosis/ROC.png'), 'h-36 mx-auto px-4', 'h-36 shadow']]],
        ['Coursera', 'AI for Medical Prognosis', require('../assets/Coursera.svg'), ['https://www.coursera.org/learn/ai-for-medical-prognosis', 'Course Link', ['fas', 'link']], ['https://www.coursera.org/account/accomplishments/certificate/YMJ6UAH6ZR75', 'Certificate', ['fas', 'certificate']], '<p>' +
        'This was the second course I completed within the AI for Medicine specialization, covering interesting models that varied from my previous focus on Neural Networks.  These modules consisted of Linear and Tree-Based prognosis models, as well as utilizing probability to build flexible models.  This was an engaging' +
        ' departure from learning about all the diverse variations of Neural Networks, and allowed me to realize that certain applications of Machine Learning require unique models to successfully implement.</p>', [[require('../assets/Prognosis/SHAP.png'), 'h-36 mx-auto px-4', 'h-36 shadow'], [require('../assets/Prognosis/Survival.png'), 'h-36 mx-auto ', 'h-36 shadow']]]]]
      ]
    }
  },
  methods: {
    isMobile: function () {
      console.log('Is mobie?' + window.innerWidth)
      return window.innerWidth <= 765
    }
  },
  created: function () {
    console.log(this.page)
    console.log(this.easterEggVar)
  }
}
</script>

<style>
.slide-enter-active, .slide-leave-active {
  transition: all 2s ease;
}

.slide-enter-from, .slide-leave-to {
  transform: translateY(1000px)
}
</style>
